import { render, staticRenderFns } from "./DominioEditInformation.vue?vue&type=template&id=1d3b854a&"
import script from "./DominioEditInformation.vue?vue&type=script&lang=js&"
export * from "./DominioEditInformation.vue?vue&type=script&lang=js&"
import style0 from "./DominioEditInformation.vue?vue&type=style&index=0&id=1d3b854a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports